export default __webpack_public_path__ + "static/media/arrow-left.e8269a16.svg";